
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
	<path
		d="M14.625 2.4668H2.25V4.7168H3.375V3.5918H14.625V4.7168H15.75V2.4668H14.625ZM3.53981 10.5066L4.33519 11.302L8.4375 7.19967V15.9668H9.5625V7.19967L13.6648 11.302L14.4602 10.5066L9 5.04642L3.53981 10.5066Z" />
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'UploadSimple',
    }) as DefineComponent
    </script>
    